// Module
var code = " <mat-radio-button *ngIf=\"editable\" [name]=\"name\" [disabled]=\"!enabled\" [color]=\"color\" [checked]=\"checked\" (change)=\"onChange($event.checked)\">{{ label }}</mat-radio-button> <mat-icon *ngIf=\"!editable &amp;&amp; checked\" svgIcon=\"gh:done\"></mat-icon>";
// Exports
module.exports = code;